import React from 'react';
import {useSelector} from 'react-redux';

// import {pushga} from '@ibibo/ga-utils';

import * as S from './Filters.styles';

import {hotelChainListSelectorFn} from '../../redux/selectors';

import {ArrayTogglerBehaviorTypes} from '../../../../hooks/useArrayToggler';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';
import {SrpGAEvents} from '../../../../../shared/config/ga-config';

const HotelChainFilter = ({updateFilter, hotelChainFilter}) => {
  const hotelChainFilterList = useSelector(hotelChainListSelectorFn);

  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({chain: item.map(chainItem => chainItem)});
    // pushga({
    //   eventCategory: SrpGAEvents.hotelSrpFilterClicked,
    //   eventAction: `HotelChain: ${itemUnderAction}`,
    //   eventLabel: isSelected,
    // });
  };

  return (
    <CheckBoxList
      name="HOTEL CHAIN"
      data={hotelChainFilterList}
      lookup={item => item}
      type={ArrayTogglerBehaviorTypes.multiSelect}
      renderItem={item => <S.TextTruncatorSpan>{item}</S.TextTruncatorSpan>}
      actionHandler={onFilterSelect}
      defaultState={hotelChainFilter || []}
      resetHandlerProp={() => {
        updateFilter({chain: []});
      }}
      maxLength={3}
    />
  );
};

export default React.memo(HotelChainFilter);
